# Gesture events
Gestures = {}
Gestures._prefix = "gesture:"

# Pan
Gestures.Pan = "pan" # This event includes all the other Pan events
Gestures.PanStart = "panstart"
Gestures.PanMove = "panmove"
Gestures.PanEnd = "panend"
Gestures.PanCancel = "pancancel"
Gestures.PanLeft = "panleft"
Gestures.PanRight = "panright"
Gestures.PanUp = "panup"
Gestures.PanDown = "pandown"

# Pinch
Gestures.Pinch = "pinch" # This event includes all the other Pinch events
Gestures.PinchStart = "pinchstart"
Gestures.PinchMove = "pinchmove"
Gestures.PinchEnd = "pinchend"
Gestures.PinchCancel = "pinchcancel"
Gestures.PinchIn = "pinchin"
Gestures.PinchOut = "pinchout"

# Press
Gestures.Press = "press"
Gestures.PressUp = "pressup"

# Rotate
Gestures.Rotate = "rotate" # This event includes all the other Rotate events
Gestures.RotateStart = "rotatestart"
Gestures.RotateMove = "rotatemove"
Gestures.RotateEnd = "rotateend"
Gestures.RotateCancel = "rotatecancel"

# Swipe
Gestures.Swipe = "swipe"
Gestures.SwipeLeft = "swipeleft"
Gestures.SwipeRight = "swiperight"
Gestures.SwipeUp = "swipeup"
Gestures.SwipeDown = "swipedown"

# Tap
Gestures.Tap = "tap"
Gestures.SingleTap = "singletap"
Gestures.DoubleTap = "doubletap"

# To determine gesture events, we prefix the value with rotate
for k, v of Gestures
	continue if k is "_prefix"
	Gestures[k] = "#{Gestures._prefix}#{v}"

exports.Gestures = Gestures


/** WEBPACK FOOTER **
 ** ./framer/Gestures.coffee
 **/